// src/features/school/schoolSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchSchoolBySubdomain = createAsyncThunk(
  'school/fetchSchoolBySubdomain',
  async (subdomain, thunkAPI) => {
    try {
      const response = await fetch(`${BASE_URL}/api/v1/getSchoolBySubdomain/${subdomain}`);
      const data = await response.json();

      if (!data.success) {
        return thunkAPI.rejectWithValue(data.message || 'Failed to load school info.');
      }

      return data.school;
    } catch (error) {
      return thunkAPI.rejectWithValue('Something went wrong. Please try again.');
    }
  }
);

const schoolSlice = createSlice({
  name: 'school',
  initialState: {
    school: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSchoolState: (state) => {
      state.school = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchoolBySubdomain.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchoolBySubdomain.fulfilled, (state, action) => {
        state.school = action.payload;
        state.loading = false;
      })
      .addCase(fetchSchoolBySubdomain.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSchoolState } = schoolSlice.actions;

export default schoolSlice.reducer;
